function useEmployeePerformanceLearning() {
  return {};
}

export default useEmployeePerformanceLearning;
